import React from "react";
import TopicCard from "../shared/Topic";
import topicsList from "../../data/topics.json";

const Topics = ({ style }) => {
  return (
    <div className={style.topics}>
      <h2 className={style.header}>
        At Hopa UK, wellness is more than a product – it’s a lifestyle.
      </h2>
      {topicsList.topics.map((topic) => (
        <TopicCard
          key={topic.id}
          reverse={Number(topic.id) % 2 === 0}
          {...topic}
        />
      ))}
    </div>
  );
};

export default Topics;
